export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数字"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["姓名"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["行动"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["编辑有关收集器的信息"])}
}